const SCENARIOS = [
  {
    industry: "Home Services",
    ref: "CASE-01",
    problem: "A service business missing inbound leads after hours",
    bottlenecks: [
      "Calls after 6pm go to voicemail; nobody follows up until next day",
      "Website form emails sit unread until morning",
      "No record of how many leads actually get replied to",
    ],
    fix: "AI voice + SMS responder captures caller intent, books next-day slots, and logs every inbound to a single pipeline view.",
  },
  {
    industry: "Ecommerce",
    ref: "CASE-02",
    problem: "An ecommerce brand with weak follow-up and poor conversion flow",
    bottlenecks: [
      "Abandoned-cart flow sends one generic email 24h late",
      "Support tickets repeat the same 5 questions manually",
      "No visibility into which channel actually drives repeat buyers",
    ],
    fix: "AI-assisted support triage + behaviour-based recovery flow + weekly KPI digest. Same team, more recovered revenue.",
  },
  {
    industry: "Real Estate",
    ref: "CASE-03",
    problem: "A real estate workflow with too much admin and slow response time",
    bottlenecks: [
      "Lead qualification handled by agents during showings",
      "Listing updates copy-pasted across 4 portals",
      "Buyer questions go unanswered on weekends",
    ],
    fix: "AI pre-qualifier + weekend auto-responder + single source of truth for listings. Agents talk to qualified buyers only.",
  },
  {
    industry: "Ops-Heavy Small Team",
    ref: "CASE-04",
    problem: "A small business stuck in spreadsheets and manual reporting",
    bottlenecks: [
      "End-of-month reporting = 2 full days of copy-paste",
      "Status updates depend on one person being at their desk",
      "No alerts when something's going sideways mid-month",
    ],
    fix: "Automated data pipeline + weekly exec summary + real-time exception alerts. Reporting drops from days to minutes.",
  },
];

export default function SampleOutcomes() {
  return (
    <section
      className="bg-[#FAFAFA] border-b border-zinc-200"
      data-testid="scenarios-section"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="max-w-3xl reveal">
          <div className="flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-orange-600" />
            <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">
              Example Bottleneck Scenarios
            </span>
          </div>
          <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-zinc-950">
            What a bottleneck actually looks like.
          </h2>
          <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
            These are illustrative scenarios — not client case studies — to show how we
            think about diagnosis and the kind of fixes we typically recommend.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-px bg-zinc-200 border border-zinc-200">
          {SCENARIOS.map((s, i) => (
            <article
              key={s.ref}
              className="bg-white p-8 sm:p-10 flex flex-col reveal"
              data-testid={`scenario-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-orange-600">
                  {s.industry}
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400">
                  {s.ref}
                </span>
              </div>
              <h3 className="mt-5 font-display font-semibold text-2xl sm:text-[26px] tracking-tight text-zinc-950 leading-snug">
                {s.problem}
              </h3>

              <div className="mt-6">
                <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                  Bottlenecks observed
                </div>
                <ul className="mt-3 space-y-2">
                  {s.bottlenecks.map((b) => (
                    <li key={b} className="flex gap-3 text-sm text-zinc-700">
                      <span className="font-mono text-orange-600">×</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-6 pt-6 border-t border-zinc-200">
                <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                  Practical fix
                </div>
                <p className="mt-3 text-zinc-800 leading-relaxed">{s.fix}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
